import { useManageComputation } from '../../../Forms/RMAReturnItemInfo/hooks'
import useGetItemToReturn from '../../../hooks/useGetItemToReturn'

const useManageItemDetail = ({
  orderDetails,
  partSku,
  selectedPart,
  eligibleStatuses,
  buttonLabel,
  submitSelect,
}) => {
  const {
    customers_email_address: customerEmailAddress,
  } = { ...orderDetails }

  const item = useGetItemToReturn({
    orderDetails,
    partSku,
  })

  const {
    order_item_id: itemOrderId,
    brandText,
    sku: partNumber,
    order_item_status: orderItemStatus = '',
    parentSku,
    qty: orderQty = 0,
    available_return_qty: qty,
    list: itemPrice,
    sku_title: skuTitle,
    returnQty: returnQuantity,
    returnRequest = {},
    ImageURL: imageSrc,
    productText,
  } = { ...item }

  const {
    qtyRange, setSelectedQty, itemPriceParsed, qtyToCompute, itemTotal, eligibleRMA,
  } = useManageComputation({
    returnQuantity,
    qty,
    selectedPart,
    partNumber,
    returnRequest,
    eligibleStatuses,
    orderItemStatus,
    buttonLabel,
    submitSelect,
    orderQty,
    itemPrice,
  })

  return {
    brandText,
    partNumber,
    orderItemStatus,
    parentSku,
    orderQty,
    qty,
    itemPrice,
    skuTitle,
    returnQuantity,
    returnRequest,
    imageSrc,
    productText,
    qtyRange,
    setSelectedQty,
    itemPriceParsed,
    qtyToCompute,
    itemTotal,
    eligibleRMA,
    itemOrderId,
    customerEmailAddress,
  }
}

export default useManageItemDetail
